export default __webpack_public_path__ + "static/media/Africa_Women_CEOs_Network_logo.5b9cd674.png";